import React from "react";
import ScoreRing from "../components/ScoreRing";
import Stars from "../components/Stars";
import RatingHistoryGraph from "../components/RatingHistoryGraph";
import { useAppState } from "../state/AppStateContext";
import { t } from "../i18n/strings";
import { colorForScore, verdictForScore } from "../utils/scoring";

export default function CheckScreen() {
  const { lang, plateInput, plateValid, loading, onPlateInput, check, resultItem, closeResult, rate } = useAppState();

  if (resultItem) {
    const score = resultItem.score;
    return (
      <section style={styles.result}>
        <div style={{ ...styles.plate, color: colorForScore(score) }}>{resultItem.plate}</div>
        <ScoreRing score={score} />
        <div style={{ ...styles.verdict, color: colorForScore(score) }}>{verdictForScore(score, lang)}</div>
        <div style={styles.helper}>{typeof score === "number" ? t(lang, "ridersRated") : t(lang, "noRatingsYet")}</div>
        <div style={styles.ratePrompt}>{resultItem.stars ? t(lang, "thanks") : t(lang, "ratePrompt")}</div>
        <Stars value={resultItem.stars} onChange={rate} />
        <RatingHistoryGraph taxi={resultItem} lang={lang} />
        <button type="button" className="btn" style={styles.secondaryButton} onClick={closeResult}>{t(lang, "checkAnother")}</button>
      </section>
    );
  }

  function submit(event) {
    event.preventDefault();
    check();
  }

  return (
    <section style={styles.check}>
      <form onSubmit={submit} style={styles.form}>
        <h1 style={styles.title}>{t(lang, "checkPrompt")}</h1>
        <p style={styles.subtitle}>{t(lang, "checkSub")}</p>
        <input className="input" value={plateInput} onChange={(event) => onPlateInput(event.target.value)} placeholder={t(lang, "placeholder")} autoComplete="off" autoCapitalize="characters" aria-label={t(lang, "placeholder")} style={styles.input} />
        <button className="btn btn-primary btn-block" type="submit" disabled={!plateValid || loading} style={styles.checkButton}>{t(lang, "checkButton")}</button>
      </form>
    </section>
  );
}

const styles = {
  check: { minHeight: "100%", display: "grid", placeItems: "center", padding: "30px 18px 50px", textAlign: "center" },
  form: { width: "100%", maxWidth: 360 },
  title: { margin: "0 0 8px", fontFamily: "var(--font-heading)", fontSize: 30, lineHeight: 1.1 },
  subtitle: { maxWidth: 300, margin: "0 auto 26px", color: "var(--color-neutral-600)" },
  input: { height: 74, marginBottom: 16, border: "2px solid var(--color-accent)", borderRadius: 20, textAlign: "center", fontFamily: "var(--font-heading)", fontSize: 30, letterSpacing: 3 },
  checkButton: { height: 64, marginTop: 0, fontSize: 20 },
  result: { minHeight: "100%", display: "flex", flexDirection: "column", alignItems: "center", padding: "18px 18px 40px", textAlign: "center" },
  plate: { marginBottom: 12, fontFamily: "var(--font-heading)", fontSize: 26, letterSpacing: 2 },
  verdict: { marginTop: 8, fontFamily: "var(--font-heading)", fontSize: 27 },
  helper: { margin: "5px 0 18px", color: "var(--color-neutral-600)", fontSize: 14 },
  ratePrompt: { marginBottom: 8, color: "var(--color-neutral-700)", fontSize: 14 },
  secondaryButton: { marginTop: 20, padding: "11px 24px", background: "var(--panel)", color: "var(--color-text)", fontSize: 15 },
};
